import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Clickable, Popover } from '@moda/om';
import { Z_INDEXES } from '../../generated/zIndexes';
import { useUser } from '../../hooks/useUser';
import { useAuthModal } from '../../hooks/useAuthModal';
import { AccountLinks } from '../AccountLinks';
import { Link } from '../Link';

import './SitePromoBannerLink.scss';
import { useEnableClubModaTreatment } from '../../hooks/useEnableClubModaTreatment';

const SitePromoBannerLinkSignedOut: React.FC = () => {
  const { openAuthModal } = useAuthModal();

  const enableClubModaTreatment = useEnableClubModaTreatment();

  const handleClick = useCallback(() => {
    openAuthModal();
  }, [openAuthModal]);

  return (
    <Clickable
      className={classNames('SitePromoBannerLink', {
        'SitePromoBannerLink--club-enabled': enableClubModaTreatment
      })}
      data-test-id="sign-in-button"
      onClick={handleClick}
    >
      Sign In
    </Clickable>
  );
};

const SitePromoBannerLinkSignedIn: React.FC<{ firstName: string | null }> = ({ firstName }) => {
  const enableClubModaTreatment = useEnableClubModaTreatment();

  return (
    <Popover
      className="SitePromoBannerLink__popover"
      zIndex={Z_INDEXES['site-promo-banner-popover']}
      content={<AccountLinks />}
      anchor="topRight"
    >
      <Link
        className={classNames('SitePromoBannerLink', {
          'SitePromoBannerLink--club-enabled': enableClubModaTreatment
        })}
        to="/account"
      >
        {firstName ? `Hi, ${firstName}` : 'Welcome!'}
      </Link>
    </Popover>
  );
};

export const SitePromoBannerLink: React.FC = () => {
  const { user } = useUser();

  return user.isLoggedIn ? (
    <SitePromoBannerLinkSignedIn firstName={user.firstName} />
  ) : (
    <SitePromoBannerLinkSignedOut />
  );
};
